<!--
  MapLocation.vue
    メンバ位置情報送信Component(app)
-->

<!-- -------------------------------------------------------------------------------- -->
<template>
  <div>
    <map-area :pmapid="mMapName" ref="mapobj" class="hm-map-area"></map-area>

    <v-layout wrap align-center>
      <v-flex xs2>
        <v-btn flat icon @click="onClickGlIcon">
          <v-icon medium color="primary">location_on</v-icon>
        </v-btn>
      </v-flex>
      <v-flex xs4 text-xs-center>Lat: {{ mGeoLocation.lat }}</v-flex>
      <v-flex xs4 text-xs-center>Lon: {{ mGeoLocation.lon }}</v-flex>
      <v-flex xs2 text-xs-center>
        <v-btn v-if="mMapFormValid" fab small color="blue lighten-1" @click="onClickSendIcon">
          <v-icon color="white">send</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>

    <div class="hm-ml-text hm-clr-primary">
      送信メモ
    </div>
    <!--
    <div v-touch="{left: () => onSwipe('left')}">
    -->
    <div>
      <div class="hm-ml-memo">
        <v-form v-model="mMapFormValid">
          <v-textarea
            v-model="mPosMsg"
            :rules="[mPosMsgRules.counter]"
            rows=1
            auto-grow
            label="Memo"
            box
          ></v-textarea>
        </v-form>
      </div>
      <!--
      <v-btn color="primary" @click="onClickMainOffice">Demo本社</v-btn>
      <v-btn color="primary" @click="onClickOsaka">Demo大阪</v-btn>
      -->
    </div>

    <info-dialog-send ref="infoDialogSend">
      <div slot="msg">位置情報を送信しました</div>
    </info-dialog-send>
    <!-- GNSS取得失敗Alart -->
    <errorinfo-dialog ref="errorInfoDialog">
      <div slot="msg">Code : {{ mErrCode }}<br />{{ mErrMsg }}</div>
    </errorinfo-dialog>
    <errorinfo-dialog-send ref="errorInfoDialogSend">
      <div slot="msg">位置情報の送信に失敗しました</div>
    </errorinfo-dialog-send>
    <confirm-dialog ref="confirmDialog">
      <div slot="msg">{{ mConfirmMsg }}</div>
    </confirm-dialog>
    <warning-dialog ref="warningDialog">
      <div slot="msg">{{ mWarningMsg }}</div>
    </warning-dialog>
    <error-confirm-dialog ref="errorConfirmDialog">
      <div slot="msg">{{mErrMsg}}</div>
    </error-confirm-dialog>
  </div>
</template>

<!-- -------------------------------------------------------------------------------- -->
<script>
//import { ROUTE_NAME } from '@/router/routes'
//import MapOSM from '@/components/MapOSM'
import { ROUTE_PATH } from '@/router/routes'
import MapOSMOL from '@/components/MapOSMOL'
import SendGeoLocationBtn from '@/components/parts/SendGnssFloatBtn'
import InfoDialog from '@/components/dialogs/SystemInfoDialog'
import ErrorInfoDialog from '@/components/dialogs/ErrorInfoDialog'
import WarningDialog from '@/components/dialogs/WarningDialog'
import ConfirmDialog from '@/components/dialogs/ConfirmDialog'
import ErrorConfirmDialog from '@/components/dialogs/ErrorConfirmDialog'
import { getGeoLocation, getNowDatetimeMoment, formatDateMoment, isNullorUndefined } from '@/common'

//const GNSS_TIMEOUT = 10000  // [msec]

export default {
  name: 'MapLocation',
  data: () => ({
    mMapName: 'hm-map',
    mGeoLocation: {lon: 'no data', lat: 'no data'},
    mMapFormValid: true,
    mMapZoom: 15,
    mPosMsg: '',
    mPosMsgRules: {
      counter: v => ((v == null) || (v.length <= 150)) || 'メモ欄は150文字以内で入力してください',
    },
    mErrCode: '',
    mErrMsg: '',
    mWarningMsg: '',
    mConfirmMsg: '',
  }),
  components: {
    'map-area': MapOSMOL,
    'send-geolocation-btn': SendGeoLocationBtn,
    'info-dialog-send': InfoDialog,
    'errorinfo-dialog': ErrorInfoDialog,
    'errorinfo-dialog-send': ErrorInfoDialog,
    'warning-dialog': WarningDialog,
    'confirm-dialog': ConfirmDialog,
    'error-confirm-dialog': ErrorConfirmDialog,
  },
  mounted: function () {
    this.$log.debug('# MapLocation mounted. (app)')
    // 表示ページをmapに変更
    this.$store.dispatch('aChangeCurrentPage', 'map')
    // 送信ボタン表示
    this.$store.commit('setSendGnssVisible', true)
    // Momo欄クリア
    this.mPosMsg = ''
    this.mMapFormValid = true
    // GNSS取得
    this.$refs.mapobj.renderMap()
    this.getGeoLocation()
  },
  destroyed: function () {
    this.$log.debug('# MapLocation destroyed.')
    // 送信ボタン非表示
    this.$store.commit('setSendGnssVisible', false)
    this.mMapFormValid = true
  },
  methods: {
    /* swipeは無効化
    onSwipe: function (direction) {
      switch (direction) {
        case 'left':
          this.onSwipeLeft()
          break
        default:
          break
      }
    },
    // -------------------------------------------------------------------------
    onSwipeLeft: function () {
      this.$router.push({
        name: ROUTE_NAME.ROUTE_WHEREABOUTS_INFO,
        params: { id: this.$store.getters.loginUserId }
      })
    },
    */
    // -------------------------------------------------------------------------
    onClickSend: function () {
      this.$log.debug('geolocation sent.')
    },
    // -------------------------------------------------------------------------
    // GNSS位置情報取得
    getGeoLocation: async function () {
      const locate = await getGeoLocation(this.$store.getters.isMobile, this.$store.getters.isGnssReady)
      if (locate.result === 'ng') {
        this.mWarningMsg = '位置情報が取得できませんでした。GPSがONになっていることを確認してください。'
        this.$refs.warningDialog.$emit('show')
      }
      else {
        this.$refs.mapobj.setMarker(this.mMapZoom, Number(locate.lon), Number(locate.lat))
        locate.lon = Number(locate.lon).toFixed(5)
        locate.lat = Number(locate.lat).toFixed(5)
      }
      this.mGeoLocation.lat = locate.lat
      this.mGeoLocation.lon = locate.lon
    },
    // -------------------------------------------------------------------------
    // LocationIconクリック時の処理
    onClickGlIcon: function () {
      // GeoLocation情報を再取得
      this.$refs.mapobj.clearMarker()
      this.getGeoLocation()
    },
    // -------------------------------------------------------------------------
    onClickSendIcon: async function () {
      if (isNullorUndefined(this.$store.getters.loginUserInfo.staff_id) ||
          isNullorUndefined(this.$store.getters.loginUserCompanyId)) {
        this.$log.error('user id or company id is null or undefined.')
        this.$refs.errorDialogSend.$emit('show')
        return
      }

      if (isNullorUndefined(this.mGeoLocation.lat) ||
          this.mGeoLocation.lat === '' ||
          Number.isNaN(Number(this.mGeoLocation.lat))) {
        this.mConfirmMsg = '位置情報が取得できていません。このまま送信してよろしいですか？'
        this.$refs.confirmDialog.$emit('show', this.sendGeoOkCallback)
        return
      }
      this.sendGeoLocation()
    },
    // -------------------------------------------------------------------------
    sendGeoOkCallback: function () {
      this.sendGeoLocation()
    },
    // -------------------------------------------------------------------------
    sendGeoLocation: async function () {
      let send_datetime = formatDateMoment(getNowDatetimeMoment(), 'YYYY-MM-DD HH:mm:ss.SSS')
      const staff_id = this.$store.getters.loginUserInfo.staff_id
      let sendData = {
        companyId: this.$store.getters.loginUserCompanyId,
        memberId: staff_id,
        geolocation: {
          lat: this.mGeoLocation.lat,
          lon: this.mGeoLocation.lon,
          msg: this.mPosMsg,
          send_time: send_datetime,
        },
      }

      const result = await this.$store.dispatch('aUpdateGeoLocation', sendData)
      if (result.error || result.body.error) {
        if (result.status === 'IpError') {
          this.mErrMsg = 'このIPアドレスからのアクセスは許可されていません'
          this.$refs.errorConfirmDialog.$emit('show', this.dispLoginPage)
        }
        else {
          this.$refs.errorDialogSend.$emit('show')
        }
      }
      else {
        this.$refs.infoDialogSend.$emit('show')
      }
    },
    // -------------------------------------------------------------------------
    // IPエラーダイアログのコールバック関数
    dispLoginPage: function () {
      this.$router.push(ROUTE_PATH.ROUTE_LOGIN)
    },
  }
}
</script>

<!-- -------------------------------------------------------------------------------- -->
<style scoped>
.hm-map-area {
  width: 95%;
  height: 35vh;
  margin: 10px auto;
}
.hm-ml-memo {
  margin: 10px auto;
  width: 90vw;
  /*background-color: #fbefef;*/
}
.hm-ml-text {
  margin-left: 10px;
  padding-top: 10px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/MapLocation.vue